// extracted by mini-css-extract-plugin
export default {"debounceInput":"HorizontalDebounceInput_debounceInput__mfVHa"};